import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import './faq.css'
import q1 from '../../images/FAQ/Group 265.png'
import q2 from '../../images/FAQ/Group 267.png'
import q3 from '../../images/FAQ/Group 270.png'
import q4 from '../../images/FAQ/Group 271.png'
import vector1 from '../../images/FAQ/Group 266.png'
import vector2 from '../../images/FAQ/Group 273.png'
import human from '../../images/FAQ/thinker.svg'
import { Link } from 'react-router-dom'
import Spinner from '../Spinner/Spinner'

const FAQ = () => {
  const [faqs, setFaqs] = useState([])
  const [loading, setLoading] = useState(false)
  const [openedFaqs, setOpenedFaqs] = useState([])
  const handleFaqClick = (faqId) => {
    if (openedFaqs.includes(faqId)) {
      setOpenedFaqs((prev) => prev.filter((id) => id !== faqId))
    } else {
      setOpenedFaqs((prev) => [...prev, faqId])
    }
  }

  const getFaqs = async () => {
    setLoading(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/faqs`,
        {
          method: 'GET',
        }
      )
      const data = await response.json()
      setFaqs(data?.faqs ?? [])
    } catch (error) {
      console.error('getFaqs error', error)
      setFaqs([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getFaqs()
  }, [])
  document.title = 'Hustlemad | FAQ'
  if (loading) {
    return <Spinner />
  }
  
  return (
    <>
      <div className='faqmain'>
        <section className='faq-top-section'>
          <div className='top-container'>
            <div className='top-left'>
              <div className='q1'>
                <img src={q1} alt='' className='q1Img' />
              </div>
              <div className='vector1'>
                <img src={vector1} alt='' className='vector1Img' />
              </div>
              <div className='q2'>
                <img src={q2} alt='' className='q2Img' />
              </div>
            </div>
            <div className='top-middle'>
              <h1>Frequently Asked Questions</h1>
              <p>
                Don't worry, you're not alone! Here are some of the top{' '}
                <br></br>
                questions we get asked all of the time.
              </p>
            </div>
            <div className='top-right'>
              <div className='q3'>
                <img src={q3} alt='' className='q3Img' />
              </div>
              <div className='vector2'>
                <img src={vector2} alt='' className='vector2Img' />
              </div>
              <div className='q4'>
                <img src={q4} alt='' className='q4Img' />
              </div>
            </div>
          </div>
        </section>

        <section className='faq-questions-section'>
          <div className='questions-container'>
            {faqs
              .sort((a, b) => (a.order || 0) - (b.order || 0))
              .map((faq, index, sortedArray) => {
                const isOpen = openedFaqs.includes(faq._id)
                const isLast = index === sortedArray.length - 1
                return (
                  <React.Fragment key={faq._id}>
                    <div className={`row1 ${isLast ? 'lastrow' : ''}`}>
                      <div className='content'>
                        <p className='qs'>{faq.question}</p>
                        <div className={isOpen ? 'qsa' : 'qsaF'}>
                          <p style={{ whiteSpace: 'pre-line' }}>{faq.answer}</p>
                        </div>
                      </div>
                      <button
                        className='icon'
                        onClick={() => handleFaqClick(faq._id)}
                      >
                        {isOpen ? (
                          <FontAwesomeIcon
                            className='xmark'
                            icon={faCircleXmark}
                          />
                        ) : (
                          <FontAwesomeIcon className='plus' icon={faPlus} />
                        )}
                      </button>
                    </div>
                    {!isLast && <hr className='greyline' />}
                  </React.Fragment>
                )
              })}
          </div>
        </section>

        <section className='faq-lower-section'>
          <div className='further-more'>
            <div className='lower-left'>
              <h1>Can’t find what you’re looking for?</h1>
              <p>
                You can post your question. Our team will reach out to you as
                soon as possible!
              </p>
              <button className='contact_us'>
                <Link to='/contact' className='contactlink'>
                  Contact Us
                </Link>
              </button>
            </div>
            <div className='lower-right'>
              <img src={human} alt='' className='humanpic' />
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
export default FAQ
